<template>
  <div class="service-areas">
    <b-container>
      <div class="header-section text-center mb-5">
        <h2 class="main-title">Serving Communities Across New Jersey</h2>
        <p class="subtitle">
          Fast, reliable garage door service throughout Bergen County. We're
          your local experts with deep community roots.
        </p>
      </div>

      <b-row>
        <b-col cols="12" lg="8">
          <h3 class="section-title mb-4">Our Service Areas</h3>

          <b-row>
            <b-col
              v-for="(area, index) in serviceAreas"
              :key="index"
              cols="12"
              md="4"
              class="mb-3"
            >
              <router-link
                :to="`/service-areas/${area.name
                  .toLowerCase()
                  .replace(/\s+/g, '-')}`"
                class="text-decoration-none"
              >
                <div class="area-card">
                  <div class="area-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z"
                          stroke="#0d47a1"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z"
                          stroke="#0d47a1"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <h4 class="area-name">{{ area.name }}</h4>
                  <!-- <div class="area-time">
                  <img :src="area.subicon" alt="subicon" width="15px" />
                  <span>{{ area.time }}</span>
                </div> -->
                </div>
              </router-link>
            </b-col>
          </b-row>

          <div class="coverage-details">
            <h3 class="section-title mb-4">Coverage Area Details</h3>
            <b-row>
              <b-col cols="12" md="6">
                <div class="detail-item">
                  <strong>Primary Service Zone:</strong> Bergen County
                </div>

                <div class="detail-item">
                  <strong>Service Radius:</strong> 30 miles from base location
                </div>
              </b-col>
              <b-col cols="12" md="6">
                <div class="detail-item">
                  <strong>Response Time:</strong> Within 2 hours
                </div>
                <div class="detail-item">
                  <strong>Emergency Service:</strong> Available 24/7
                </div>
                <div class="detail-item">
                  <strong>Travel Charges:</strong> No additional fees within
                  service area
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col cols="12" lg="4">
          <div class="cta-card">
            <div class="cta-icon">
              <svg
                aria-hidden="true"
                class="emergency-icon"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="white"
                width="70px"
                height="70px"
              >
                <path
                  d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
                ></path>
              </svg>
            </div>
            <h3 class="cta-title">Ready to Help!</h3>
            <p class="cta-description">
              Need garage door service in your area? We're standing by to
              provide fast, professional assistance.
            </p>
            <b-button class="cta-button w-100" href="tel:(551) 408-0587">
              Call (551) 408-0587
            </b-button>
            <div class="cta-features p-2 pb-sm-0">
              <div class="feature-item">
                <i class="fas fa-map-marker-alt"></i>
                <span>Based in Bergen County</span>
              </div>
              <div class="feature-item">
                <i class="fas fa-clock"></i>
                <span>Available 24/7</span>
              </div>
              <div class="feature-item">
                <i class="fas fa-bolt"></i>
                <span>2-Hour Emergency Response</span>
              </div>
            </div>
          </div>

          <div class="guarantee-card mt-4">
            <h3 class="guarantee-title mb-4">Service Guarantee</h3>
            <div class="guarantee-items">
              <ul class="guarantee-item">
                <li>Same-day service for most repairs</li>
                <li>No travel charges within service area</li>
                <li>100% satisfaction guarantee</li>
              </ul>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import clock from "../assets/imgs/clock.png";
export default {
  name: "ServiceAreasSection",
  data() {
    return {
      serviceAreas: [
        {
          name: "Englewood",
          time: "0 min",
          icon: null,
          subicon: clock,
          title: "Fast Garage Door Services in Englewood",
          alt: "Garage door services in Englewood, NJ",
        },
        {
          name: "Bergenfield",
          time: "5 min",
          icon: null,
          subicon: clock,
          title: "Fast Garage Door Services in Bergenfield",
          alt: "Garage door services in Bergenfield, NJ",
        },
        {
          name: "Englewood Cliffs",
          time: "3 min",
          icon: null,
          subicon: clock,
          title: "Fast Garage Door Services in Englewood Cliffs",
          alt: "Garage door services in Englewood Cliffs, NJ",
        },
        {
          name: "Fort Lee",
          time: "8 min",
          icon: null,
          subicon: clock,
          title: "Fast Garage Door Services in Fort Lee",
          alt: "Garage door services in Fort Lee, NJ",
        },
        {
          name: "Leonia",
          time: "10 min",
          icon: null,
          subicon: clock,
          title: "Fast Garage Door Services in Leonia",
          alt: "Garage door services in Leonia, NJ",
        },
        {
          name: "Teaneck",
          time: "12 min",
          icon: null,
          subicon: clock,
          title: "Fast Garage Door Services in Teaneck",
          alt: "Garage door services in Teaneck, NJ",
        },
        {
          name: "Tenafly",
          time: "7 min",
          icon: null,
          subicon: clock,
          title: "Fast Garage Door Services in Tenafly",
          alt: "Garage door services in Tenafly, NJ",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.service-areas {
  padding: 60px 0;
  background-color: #f8fbff;

  .header-section {
    margin-bottom: 60px;

    .main-title {
      font-size: 36px;
      font-weight: 700;
      color: #2d3748;
      margin-bottom: 20px;
      line-height: 1.2;
    }

    .subtitle {
      font-size: 18px;
      color: #718096;
      line-height: 1.6;
      max-width: 600px;
      margin: 0 auto;
    }
  }

  .section-title {
    font-size: 24px;
    font-weight: 700;
    color: #2d3748;
    margin-bottom: 30px;
  }
  @media (max-width: 768px) {
    .section-title {
      text-align: center;
    }
  }

  .area-card {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    height: 100%;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      transform: translateY(-2px);
    }

    .area-icon {
      color: #0d47a1;
      font-size: 24px;
      margin-bottom: 15px;
    }

    .area-name {
      font-size: 18px;
      font-weight: 600;
      color: #2d3748;
      margin-bottom: 10px;
    }

    .area-time {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #718096;
      font-size: 14px;

      i {
        margin-right: 5px;
      }
    }
  }

  .cta-card {
    background: #0d47a1;
    border-radius: 12px;
    padding: 15px 30px;
    color: white;
    text-align: center;
    @media (max-width: 1200px) {
      padding: 0 30px;
    }

    .cta-icon {
      font-size: 48px;
      color: #ffd700;
      margin-bottom: 20px;
    }

    .cta-title {
      font-size: 28px;
      font-weight: 700;
      margin-bottom: 15px;
      color: white;
    }

    .cta-description {
      font-size: 16px;
      line-height: 1.6;
      margin-bottom: 25px;
      opacity: 0.95;
    }

    .cta-button {
      background-color: #ffd700;
      border: none;
      color: #2d3748;
      font-weight: 700;
      font-size: 16px;
      padding: 15px 25px;
      border-radius: 25px;
      margin-bottom: 25px;
      transition: all 0.3s ease;

      &:hover {
        background-color: #f5d700;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
      }
    }

    .cta-features {
      .feature-item {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;
        font-size: 14px;

        i {
          margin-right: 8px;
          width: 16px;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .guarantee-card {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    .guarantee-title {
      font-size: 20px;
      font-weight: 700;
      color: #2d3748;
      text-align: center;
    }
    ul {
      padding: 12px;
      list-style: none; // remove default bullets
    }

    li {
      position: relative;
      padding-left: 20px;
      margin-bottom: 10px;
    }

    li::before {
      content: "•";
      color: #0d47a1;
      position: absolute;
      left: 0;
      top: 0;
      font-size: 18px;
      line-height: 1;
    }
    .guarantee-items {
      .guarantee-item {
        margin-bottom: 15px;
        font-size: 14px;
        color: #4a5568;

        i {
          color: #0d47a1;
          font-size: 16px;
          flex-shrink: 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .coverage-details {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

    .detail-item {
      margin-bottom: 15px;
      font-size: 15px;
      color: #4a5568;

      strong {
        color: #2d3748;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: 991.99px) {
    .cta-card,
    .guarantee-card {
      margin-top: 40px;
    }
  }

  @media (max-width: 767.99px) {
    padding: 30px 0;

    .header-section {
      .main-title {
        font-size: 25px;
      }

      .subtitle {
        font-size: 16px;
      }
    }

    .section-title {
      font-size: 20px;
    }

    .coverage-details,
    .guarantee-card {
      padding: 20px;
    }

    .cta-card {
      .cta-title {
        font-size: 24px;
      }
    }
  }
}
</style>
